import { usePostUserLogout } from '@/queries/users/usePostUserLogout';
import { trackSignout } from '@/utils/analytics';
import Cookies from 'js-cookie';
import { useDispatch } from 'react-redux';
import * as actions from '@/store/auth/actions';
import { resetParticipant } from '@/store/participant/actions';
import { useHistory } from 'react-router-dom';
import { useEffect } from 'react';
import { isEmpty, isUndefined } from 'lodash';

const LogoutScene = () => {
  const { mutate: logoutUser } = usePostUserLogout();

  useEffect(() => {
    logoutUser();
  }, []);
  
  return null;
}

export default LogoutScene;
